import { BaseType } from '../../base/base-type';
import { CreditCardStatusEnum } from '../../enum/shared/credit-card-status-enum';

export class CreditCardStatusType extends BaseType {
  public declare id: CreditCardStatusEnum;
}
